module.exports = __webpack_public_path__ + "img/head-paso2.e950ffd5.svg";